module.exports = __webpack_public_path__ + "static/media/imagenProfesionales.105dd0b1.png";